export default __webpack_public_path__ + "static/media/about-team-20.993841e8.jpg";